// @flow

import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import Colors from 'components/styles/colors'
import OwnerEvaluate from 'components/molecules/OwnerEvaluate'
import Certificated from 'components/molecules/room/HostCertificatedBox'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { ownerName } from 'frontend_core/dist/helpers/format'
import Path from 'routes/path'

const Container = styled.div`
  border: 1px solid ${Colors.grayD};
  background: #fff;
  border-radius: 3px;
  padding: 16px 18px;
  margin-bottom: 24px;
`

const HostIconContainer = styled.div`
  position: relative;
`

const HostIcon = styled.img`
  float: left;
  width: 72px;
  height: 72px;
  height: auto;
  border-radius: 50%;
`

const TopHostIcon = styled.img`
  position: absolute;
  top: 45px;
  left: 50px;
  width: 25px;
  height: 33px;
`

const HostDetailContainer = styled.div`
  margin-left: 90px;
  padding-top: 10px;
`

const DetailTitle = styled.h3`
  color: ${Colors.black};
  font-weight: normal;
  font-size: 12px;
`

const RegistedDate = styled.span`
  color: #999;
  font-size: 12px;
  margin: 6px 0;
`

const Name = styled.h3`
  font-size: 14px;
  font-weight: bold;
  margin: 6px 0;

  a {
    color: ${Colors.black};

    &:visited {
      color: ${Colors.black};
    }

    &:hover {
      text-decoration: underline;
    }
  }
`

const Profile = styled.p`
  clear: both;
  font-size: 12px;
  line-height: 1.4;
`

export default (props: Object) => (
  <Container>
    <HostIconContainer>
      <a href={Path.owner(props.username)}>
        <HostIcon src={props.profileImage} alt="" />
      </a>
      <TopHostIcon
        src={imagePath('www/common/gold_superhost.png')}
        alt={i18n.t('page.room.tophost')}
      />
    </HostIconContainer>
    <HostDetailContainer className="clearfix">
      <DetailTitle>{i18n.t('page.room.ownerTitle')}</DetailTitle>
      <Name>
        <a href={Path.owner(props.username)}>{ownerName(props)}</a>
      </Name>
      <RegistedDate>
        {i18n.t('page.room.registeredDate')}{' '}
        {moment(props.createdAt).format(i18n.t('page.shared.dateFormat1'))}
      </RegistedDate>
    </HostDetailContainer>
    <OwnerEvaluate {...props} />
    <Profile>{props.profile}</Profile>
    <Certificated />
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/molecules/ReviewOwnerBox/index.jsx